import { Card, Dialog, Stack, Typography } from "@octopus-energy/coral/atoms"
import { ConstantineCalculating } from "@octopus-energy/coral/media"
import { noop } from "@oefr/utils/react"
import { useTranslations } from "next-intl"

export function MeterPowerAnalysisLoader({ isLoading = false }: { isLoading?: boolean }) {
    const t = useTranslations("MeterPowerAnalysisLoader")

    return (
        <Dialog
            open={isLoading}
            onClose={noop}
            ariaLabelledBy={t("label")}
            disableEscapeKeyDown
        >
            <Card
                borderless
                fullHeight
                theme="base500"
            >
                <Stack
                    flexDirection="column"
                    alignItems="center"
                >
                    <ConstantineCalculating />

                    <Stack
                        flexDirection="column"
                        alignItems="center"
                    >
                        <Typography
                            textStyle="h1"
                            textAlign="center"
                        >
                            {t("title")}
                        </Typography>
                        <Typography textAlign="center">{t("description")}</Typography>
                    </Stack>
                </Stack>
            </Card>
        </Dialog>
    )
}

MeterPowerAnalysisLoader.messages = ["MeterPowerAnalysisLoader"] as const
